const getLocaleUrlFromNodeLocale = (node_locale: string): string => {
  switch (node_locale) {
    case 'nl-NL':
    case 'nl':
      return '/nl';

    case 'en-GB':
    case 'en-UK':
    default:
      return ''; // uk doesn't need a prefix
  }
};

export default getLocaleUrlFromNodeLocale;
